import React, { PureComponent } from 'react';
import Message from 'jl-design-system/components/message/Message';
import styles from './pact-order-failed.scss';

class PactOrderFailed extends PureComponent {

  render() {
    return (
      <div className={styles.container}>
        <Message
          body="Check if the customer has received an order acknowledgement email.
            If not, please search for a corresponding order in OCCO. If you can’t find it,
            please call the Financial Admin Team (769 6448) between Mon to Fri 8:30am - 4:00pm.
            Outside hours, check Business Operating Procedure."
          className={styles.message}
          title="Sorry, it looks like payment was taken but the order may not have completed"
          type="error"
        />
      </div>
    );
  }
}

export default PactOrderFailed;
